<template>
  <div class="information" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          查岗位 - 专科可报考
        </el-text>
      </el-form-item>
      <el-form-item label="文件">
        <el-upload :data="{ type: 'GW_ZK' }" style="width: 100%;" v-model:file-list="data.file.file" :limit="1" :action="api.baseURL() + '/backend/information/importExcel'" :headers="api.tokenHeader()" multiple drag :on-remove="remove"
          :on-success="() => ElMessage.success('上传成功')" :on-error="() => ElMessage.error('上传失败')" :on-preview="(f) => util.previewElfile(f)" accept=".xls,.xlsx">
          <el-text>点击或拖转到此处上传文件（最多1个）</el-text>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'
import { da } from 'element-plus/es/locale/index.mjs'

const router = useRouter()
const loading = reactive({
  save: false,
})
const data = reactive({
  file: { file: [] },
})

api.get('/backend/kkv/getList', {
  params: {
    scene: 'INFO_F',
  }
}).then((res) => {
  if (res && res.list && res.list.length > 0) {
    const kkv = res.list.find((item) => item.kkey === 'GW_ZK')
    console.log(kkv)
    if (kkv && kkv.value) {
      data.file.file = util.json2Elfile(JSON.stringify([kkv.value]))
    }
  }
})

const save = () => {
  if (data.file.file.length === 0) {
    ElMessage.error('请先上传文件，再保存')
  }
  loading.save = true
  api.post('/backend/information/importExcel', {
    type: 'GW_ZK',
    path: JSON.parse(util.elfile2Json(data.file.file))[0],
  }).then(() => {
    ElMessage.success('保存成功')
  }).finally(() => {
    loading.save = false
  })
}

const remove = () => {
  api.post('/backend/information/remove', {
    type: 'GW_ZK',
  }).then(() => {
    ElMessage.success('删除成功')
  })
}
</script>

<style lang="less">
.information {
  margin: auto;
  max-width: 900px;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>